import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, ChevronUp } from "lucide-react";

// Full-section drawer with DISCOVER MORE (closed) / CLOSE SECTION (open).
// Listens for a global `open-drawer` CustomEvent so the hero button, welcome
// popup, and /album route can open a specific drawer by id without prop
// drilling. Also opens automatically when the URL hash matches `#<id>-open`.
export default function Drawer({ id, children }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if (e.detail && e.detail.id === id) setOpen(true);
    };
    window.addEventListener("open-drawer", handler);
    // Hash-based deep link: e.g. #vault-open
    if (typeof window !== "undefined" && window.location.hash === `#${id}-open`) {
      setOpen(true);
    }
    return () => window.removeEventListener("open-drawer", handler);
  }, [id]);

  return (
    <>
      <button
        data-testid={`drawer-toggle-${id}`}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="mt-8 w-full flex items-center justify-center gap-3 bg-[#F4C10A] text-black font-display uppercase text-sm tracking-[0.22em] py-4 hover:bg-[#FFD22C] transition-colors"
      >
        {open ? "Close Section" : "Discover More"}
        {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid={`drawer-content-${id}`}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="overflow-hidden"
          >
            <div className="pt-10">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
